// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TXKu","footer":"styles_footer__3GYyk","passCodeTooltip":"styles_passCodeTooltip__WN-1W"};